import ToastContext from '@components/Toast/ToastContext';
import React from 'react';
import { SetToastFunc, ToastSeverity } from 'types/toast';

const useToast = () => {
	const addToast = React.useContext(ToastContext) as SetToastFunc;

	const invokeToastableAction = React.useCallback(
		async (
			action: () => Promise<any>,
			labelPrefix: string,
			onComplete?: () => void
		) => {
			try {
				await action();
				addToast({
					severity: ToastSeverity.Success,
					content: intl.tr(`${labelPrefix}.success`)
				});

				onComplete?.();
			} catch (error) {
				addToast({
					severity: ToastSeverity.Error,
					content: intl.tr(`${labelPrefix}.error`),
					error
				});
			}
		},
		[addToast]
	);

	return {
		addToast,
		invokeToastableAction
	};
};

export default useToast;
